const iconApplication = "mdi-application";
const iconBrowse = "mdi-dots-vertical";
const iconConfigure = "mdi-cog-outline";
const iconLogOut = "mdi-logout";
const iconChevronDown = "mdi-chevron-down";
const iconChevronUp = "mdi-chevron-up";
const iconChevronLeft = "mdi-chevron-left";
const iconChevronRight = "mdi-chevron-right";
const iconArrowRightDrop = "mdi-arrow-right-drop-circle-outline";
const iconArrowLeftDrop = "mdi-arrow-left-drop-circle-outline";
const iconArrowDownDrop = "mdi-arrow-down-drop-circle-outline";
const iconArrowUpDrop = "mdi-arrow-up-drop-circle-outline ";
const iconJump = "mdi-debug-step-over";
const iconAccount = "mdi-account-circle";
const iconSearch = "mdi-magnify";
const iconPrinter = "mdi-printer";
const iconNavigateBack = "mdi-chevron-left";
const iconNavigateToDetails = "mdi-chevron-right";
const iconView = "mdi-table-search ";
const iconAdd = "mdi-plus";
const iconEdit = "mdi-pencil-outline";
const iconSave = "mdi-content-save-outline";
const iconTrash = "mdi-trash-can-outline";
const iconClear = "mdi-close-outline ";
const iconRefresh = "mdi-cached ";
const iconPhone = "mdi-cellphone-basic";
const iconCalendar = "mdi-calendar";
const iconCalendarMonth = "mdi-calendar-month";
const iconWarning = "mdi-alert-outline";
const iconInfo = "mdi-information-outline ";
const iconNotification = "mdi-bell-outline";
const iconNotificationAdd = "mdi-bell-plus-outline";
const iconNotificationRemove = "mdi-bell-remove-outline";
const iconNotificationCheck = "mdi-bell-check-outline";
const iconNote = "mdi-message-bulleted";
const iconAttachment = "mdi-paperclip";
const iconParts = "mdi-toolbox";
const iconAttribute = "mdi-tag-text-outline";
const iconCheck = "mdi-check";
const iconClose = "mdi-close";
const iconClock = "mdi-clock-outline";
const iconAnnouncement = "mdi-bullhorn-outline";
const iconEvents = "mdi-calendar-multiple";
const iconTask = "mdi-calendar-check-outline";
const iconRun = "mdi-run-fast";
const iconDashboard = "mdi-view-dashboard-outline";
const iconEmail = "mdi-email";
const iconMapMarker = "mdi-map-marker";
const iconAccountSupervisor = "mdi-account-group";
const iconAccountTie = "mdi-account-tie";
const iconToggleOff = "mdi-toggle-switch-off-outline";
const iconToggleOn = "mdi-toggle-switch";
const iconLockReset = "mdi-lock-reset";

export {
  iconApplication,
  iconBrowse,
  iconConfigure,
  iconLogOut,
  iconChevronDown,
  iconChevronUp,
  iconChevronLeft,
  iconChevronRight,
  iconArrowRightDrop,
  iconArrowLeftDrop,
  iconJump,
  iconAccount,
  iconArrowDownDrop,
  iconArrowUpDrop,
  iconSearch,
  iconPrinter,
  iconNavigateBack,
  iconNavigateToDetails,
  iconView,
  iconAdd,
  iconEdit,
  iconSave,
  iconTrash,
  iconPhone,
  iconClear,
  iconRefresh,
  iconCalendar,
  iconCalendarMonth,
  iconWarning,
  iconInfo,
  iconNotification,
  iconNotificationAdd,
  iconNotificationRemove,
  iconNotificationCheck,
  iconNote,
  iconAttachment,
  iconParts,
  iconAttribute,
  iconCheck,
  iconClose,
  iconClock,
  iconAnnouncement,
  iconEvents,
  iconTask,
  iconRun,
  iconDashboard,
  iconEmail,
  iconMapMarker,
  iconAccountSupervisor,
  iconAccountTie,
  iconToggleOff,
  iconToggleOn,
  iconLockReset
};
